<template>
  <div>
    <button @click="jumpTo">跳转</button>
  </div>
</template>
<script>
export default {
  name: "jumpTo",
  data() {
    return {
    };
  },
  methods:{
    jumpTo(){
      window.location.replace('https://cportal.lshmnc.com.cn/mobjsp/downpage/download.htm');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/qcwy/jumpToApp.vue